import { Link, useLocation } from "react-router-dom"
import { NavItem } from "./Navbar"

export function DesktopNavLink({ item }: { item: NavItem }) {
    const location = useLocation()
    const isActive = location.pathname === item.href
    let Icon: React.ElementType = item.icon
    return (
        <Link
            to={item.href}
            className={`flex items-center px-4 py-2.5 rounded-lg transition-all duration-200
                ${isActive 
                    ? "bg-blue-50 text-blue-600" 
                    : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                }`}
        >
            <span className="mr-3">
                <Icon className={`h-5 w-5 ${isActive ? "text-blue-500" : "text-gray-400"}`} />
            </span>
            <span className="text-sm font-medium">{item.name}</span>
        </Link>
    )
}

export const MobileNavLink = ({ href, icon: Icon, name, close }: any) => {
    const location = useLocation()
    const isActive = location.pathname === href
    return (
        <li>
            <Link 
                to={href!} 
                onClick={close} 
                className={`flex items-center p-3 rounded-lg transition-colors duration-200
                    ${isActive 
                        ? "bg-blue-50 text-blue-600" 
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    }`}
            >
                {Icon && (
                    <span className={`mr-3 ${isActive ? "text-blue-500" : "text-gray-400"}`}>
                        <Icon className="h-5 w-5" />
                    </span>
                )}
                <span className="text-sm font-medium">{name}</span>
            </Link>
        </li>
    )
};
